import React from 'react';

export default function Info(props) {
  const { focusAreasData, focus } = props;
  return (
    <section className="profile-info">
      <section className="info-section">
        <label>Certifications</label>
        <p>{props.certifications}</p>
      </section>
      <section className="info-section">
        <label>Focus Areas</label>
        {focus.length > 0 && focusAreasData ? (
          <ul>
            {focus.map(e => (
              <li key={e}>{focusAreasData.values[e].value}</li>
            ))}
          </ul>
        ) : (
          ''
        )}
      </section>
    </section>
  );
}
